(function(angular) {
    angular.module('bizPartEngage').controller('core.mypage', mypageController);
    angular.module('bizPartEngage').controller('core.mysettings', mysettingsController);
    angular.module('bizPartEngage').controller('core.mysecurity', mysecurityController);
    angular.module('bizPartEngage').controller('core.mycustomsettings', mycustomsettingsController);
    angular.module('bizPartEngage').controller('core.mycolleagues', mycolleaguesController);
    angular.module('bizPartEngage').controller('core.myleaderboards', myleaderboardsController);

    mypageController.$inject = ["$rootScope", "$state", "modules.education.service", "core.users.service", "core.level.serivce", 
        "core.event.statistics.service", "core.engage.service", "modules.certifications.service"];
    mysettingsController.$inject = ["$rootScope", "core.users.service", "$mdDialog", "$translate", "bizMediabankService", 
        "bizMediabankUploadService", "$mdToast", "$q", "bizCoreService", "bizCore", "$filter"];
    mysecurityController.$inject = ["$rootScope", "core.users.service", "$mdToast"];
    mycustomsettingsController.$inject = ["$rootScope", "core.users.service", "$mdToast"];
    mycolleaguesController.$inject = ["$rootScope", "core.unit.service"];
    myleaderboardsController.$inject = ["$rootScope", "core.unit.service", "core.leaderboard.service"];

    function mycustomsettingsController($rootScope, userService, $mdToast) {
        var vm = this;
        vm.MyForm = null;
        vm.Initialized = false;
        
        vm.Init = Init;
        vm.Save = Save;
        vm.IsFieldRestricted = IsFieldRestricted;

        function IsFieldRestricted(field) {
            if (!vm.RestrictedFields) return false;

            var f = vm.RestrictedFields.find(rf => rf.FieldType === 2 && rf.Name.toLowerCase() === field.toLowerCase());
            return f !== undefined;
        }

        function Save() {
            userService.SaveCustomProfileData(vm.User).then(SuccessCallback);
            
            function SuccessCallback(response) {
                vm.MyForm.$setPristine();
                vm.MyForm.$setUntouched();
                
                $mdToast.show($mdToast.simple().content('Successfully saved').position("bottom right"));
            }
        }

        function Init()
        {
            userService.GetProfile().then(SuccessCallback);
            userService.GetProfileRestrictedFields().then(GetProfileRestrictedFieldsSuccess);
            
            function SuccessCallback(response) {
                vm.Initialized = true;
                vm.User = response.data;
                console.log("vm.User", vm.User);
            }

            function GetProfileRestrictedFieldsSuccess(response) {
                vm.RestrictedFields = response.data;
            }
        }

        $rootScope.Initialized.then(vm.Init);
    }

    function mysecurityController($rootScope, userService, $mdToast) {
        var vm = this;
        vm.MyForm = null;
        vm.OldPassword;
        vm.NewPassword;
        vm.NewPasswordRepeat;
        vm.ShowPasswords = false;

        vm.Save = Save;
        vm.ToggleShowPassword = ToggleShowPassword;

        function ToggleShowPassword() {
            vm.ShowPasswords = !vm.ShowPasswords;
            
            document.getElementById('newPassword').setAttribute('type', vm.ShowPasswords ? 'text' : 'password');
            document.getElementById('newPasswordRepeat').setAttribute('type', vm.ShowPasswords ? 'text' : 'password');
        }

        function IsPasswordValidToSave() {
            if (vm.OldPassword && vm.OldPassword != "" && vm.NewPassword && vm.NewPassword != "" && vm.NewPassword === vm.NewPasswordRepeat)
                return true;

            return false;
        }

        function Save() {
            if (IsPasswordValidToSave() === false)
                return false;

            userService.UpdateMyPassword(vm.NewPassword, vm.OldPassword).then(UpdateMyPasswordSuccess);

            function UpdateMyPasswordSuccess(response) {
            	$mdToast.show($mdToast.simple().content(response.data).position("bottom right"));

            	vm.OldPassword = undefined;
            	vm.NewPassword = undefined;
                vm.NewPasswordRepeat = undefined;

                vm.MyForm.$setPristine();
                vm.MyForm.$setUntouched();

                return true;
            }
        }
    }
    
    function mypageController($rootScope, $state, educationService, userService, levelService, eventStatisticsService, engageService, certificationsService) {
        var vm = this;
        vm.PageMax = 20;
        vm.UserStats = undefined;
        vm.AuthToken = getBizPartAuthToken();
        vm.Mascot = mascot;

        vm.EducationCount = -1;
        vm.BlogCount = -1;
        vm.VideoCount = -1;
        vm.ScormCount = -1;
        vm.QuizCount = -1;
        vm.TotalEducationCount = -1;

        vm.Notifications = [];
        vm.NotificationsPage = 1;
        vm.ActivityLog = [];
        vm.ActivityLogPage = 1;
        vm.GainMoreExperience = [];
        vm.GainMoreExperiencePage = 1;
        vm.LastGainedExperience = [];
        vm.LastGainedExperiencePage = 1;
        vm.CertificationCount = 0;
        vm.CompletedEducationCount = 0;

        vm.GetCompletedCount = GetCompletedCount;
        vm.GetLoggedInUserNotifications = GetLoggedInUserNotifications;
        vm.GetLoggedInUserExperiencePointHistory = GetLoggedInUserExperiencePointHistory;
        vm.GetAllEventStatisticsForUser = GetAllEventStatisticsForUser;
        vm.GetSuggestions = GetSuggestions;
        vm.GoToSuggestion = GoToSuggestion;
        vm.GetSuggestionIcon = GetSuggestionIcon;
        vm.ShowCertificates = ShowCertificates;
        vm.GetUserLogStats = GetUserLogStats;
        vm.GetStatCount = GetStatCount;
        vm.Initialize = Initialize;
        vm.GoToItem = GoToItem;

        function GoToItem(item) {            
            //The types that only should be clickable for the users own items
            if ((item.Settings && ~~item.Settings.ObjectOwnerUserId > 0 && item.Settings.ObjectOwnerUserId === $rootScope.LoggedInUser.Id)) {
                switch (item.ObjectType) {
                    case 'GOAL':
                        $state.go("base.modules.goals.onegoal", { id: ~~item.ObjectId > 0 ? ~~item.ObjectId : 'new' });
                        break;
                    case 'TODO':
                        $state.go("base.modules.goals.onetask", { id: ~~item.ObjectId > 0 ? ~~item.ObjectId : 'new' });
                        break;
                    case 'ACTIVITY':
                        $state.go("base.modules.goals.activity", { id: ~~item.ObjectId > 0 ? ~~item.ObjectId : 'new' });
                        break;
                }
            }

            //The types that should be clickable for any user (as long as they have access, which should be fixed on backend)
            switch (item.ObjectType) {
                case 'HTML5':
                    $state.go("base.modules.html5education", { id: item.ObjectId });
                    break;
                case 'MediabankFile':
                    $state.go("base.modules.mediafile", { id: item.ObjectId });
                    break;
                case 'Blog':
                    $state.go("base.modules.blog", { id: item.ObjectId });
                    break;
                case 'SCORM':
                    location.href = siteRootPath + "SCORM/" + item.ObjectId;
                    break;
            }    
        }

        function GetStatCount(types) {
            var count = -1;
            if(types && vm.UserStats) {
                //We handle multiple types...
                if(types.length > 1) {
                    for(var i = 0; i < types.length; i++) {
                        for(var y = 0; y < vm.UserStats.EngageObjectLogs.length; y++) {
                            if(vm.UserStats.EngageObjectLogs[y].EngageObjectType === types[i] && vm.UserStats.EngageObjectLogs[y].Passed === true) {
                                count++;
                            }
                        }
                    }
                }
                else {
                    for(var i = 0; i < vm.UserStats.EngageObjectLogs.length; i++) {
                        if(vm.UserStats.EngageObjectLogs[i].EngageObjectType === types && vm.UserStats.EngageObjectLogs[i].Passed === true) {
                            count++;
                        }
                    }
                }
            }

            return count;
        }

        function GetUserLogStats() {
            userService.GetUserLogStats().then(function(response) {
                vm.UserStats = response.data;

                var eduCount = 0;
                var blogCount = 0;
                var videoCount = 0;
                var scormCount = 0;
                var quizCount = 0;
                for (var i = 0; i < vm.UserStats.EngageObjectLogs.length; i++) {
                    if (vm.UserStats.EngageObjectLogs[i].Passed === true) {
                        switch (vm.UserStats.EngageObjectLogs[i].EngageObjectType) {
                            case 1:
                                eduCount++;
                                break;
                            case 2:
                                blogCount++;
                                break;
                            case 3:
                                videoCount++;
                                break;
                            case 4:
                                scormCount++;
                                break;
                            case 5:
                                quizCount++;
                                break;
                        }

                    }                    
                }
                
                vm.EducationCount = eduCount;
                vm.BlogCount = blogCount;
                vm.VideoCount = videoCount;
                vm.ScormCount = scormCount;
                vm.QuizCount = quizCount;
                vm.TotalEducationCount = eduCount + scormCount;

                console.log("count done");                
            });
        }

        function ShowCertificates(){
        	$mdDialog.show({
        		templateUrl: siteRootPath + "Frontend/Core/Views/mypagecertificates.html",
        		controllerAs: "vm",
        		controller: certificateController,
				bindToController: true
        	});
			
        	certificateController.$inject = ["$mdDialog"];

        	function certificateController($mdDialog) {
        		var vm = this;

        		vm.GetCertificates = GetCertificates;

        		function GetCertificates() {

        		}
        	}
        }

        function GetCompletedCount() {
            educationService.GetCompletedCount().then(GetCompletedCountSuccess);

            function GetCompletedCountSuccess(response) {
                vm.CompletedEducationCount = response.data.Education;
                vm.CompletedEducationCount += response.data.CertificationEducation;

                vm.CertificationCount = response.data.Certification;
            }
        }

        function GetLoggedInUserNotifications(page) {
            userService.GetLoggedInUserNotifications(vm.PageMax, page).then(GetLoggedInUserNotificationsSuccess);

            function GetLoggedInUserNotificationsSuccess(response) {
                vm.Notifications = response.data;
            }
        }

        function GetLoggedInUserExperiencePointHistory(page) {
            levelService.GetLoggedInUserExperiencePointHistory(vm.PageMax, page).then(GetLoggedInUserExperiencePointHistorySuccess);

            function GetLoggedInUserExperiencePointHistorySuccess(response) {
                vm.LastGainedExperience = response.data;
            }
        }

        function GetAllEventStatisticsForUser(page) {
            eventStatisticsService.GetAllEventStatisticsForUser(page, vm.PageMax).then(GetAllEventStatisticsForUserSuccess);

            function GetAllEventStatisticsForUserSuccess(response) {
                vm.ActivityLog = response.data;
            }
        }

        function GetSuggestions(page) {
            engageService.GetSuggestions(page, vm.PageMax).then(GetSuggestionsSuccess);

            function GetSuggestionsSuccess(response) {
                vm.GainMoreExperience = response.data;
            }
        }

        function GoToSuggestion(item) {
            switch (item.ControlType) {
                case "HTML5EDUCATION":
                    $state.go('base.modules.html5education', {id: item.Value.Id});
                break;
                case "MISSION":
                    $state.go('base.modules.missionsview', {id: item.Value.Id});
                break;
            }
        }

        function GetSuggestionIcon(item) {
            switch (item.ControlType) {
                case "HTML5EDUCATION":
                    return "fa-graduation-cap";
                case "MISSION":
                    return "fa-star";
            }
        }

        function GetCertificationsForUser() {
            certificationsService.GetCertificationsForUser().then(function(response) {
                vm.UserCerts = response.data;
            });
        }

        function Initialize() {
            vm.GetCompletedCount();
            vm.GetLoggedInUserNotifications(vm.NotificationsPage);
            vm.GetAllEventStatisticsForUser(vm.ActivityLogPage);
            vm.GetSuggestions(vm.GainMoreExperiencePage);

            vm.GetUserLogStats();
            GetCertificationsForUser();

            if (IsPortalSettingTrue('IsLevelSystemEnabled')) {
                vm.GetLoggedInUserExperiencePointHistory(vm.LastGainedExperiencePage);
            }
        }

        vm.Initialize();
    }

    function mysettingsController($rootScope, userService, $mdDialog, $translate, bizMediabankService, bizMediabankUploadService, $mdToast, $q, bizCoreService, bizCoreProvider, $filter) {
        var vm = this;
        vm.MyForm = null;
        vm.Initialized = false;
        
        vm.GetUser = GetUser;
        vm.UpdateCustomFieldValue = UpdateCustomFieldValue;
        vm.GetCustomFieldValue = GetCustomFieldValue;
        
        vm.AllowSms = false;
        vm.PortalCustomerName = portalCustomerName;
        vm.NotificationSettings = notificationSettings;
        
        vm.SaveMyDetails = SaveMyDetails;
        vm.Unregister = Unregister;
        vm.AskToUnregister = AskToUnregister;
        vm.UpdateAllowSMSForLoggedInUser = UpdateAllowSMSForLoggedInUser;
        vm.GetLoggedInUserSetting = GetLoggedInUserSetting;
        vm.GetLoggedInUserSettingAsBoolean = GetLoggedInUserSettingAsBoolean;
        vm.SetFile = SetFile;
        vm.SetTempFile = SetTempFile;
        vm.GetProfileImageUrl = GetProfileImageUrl;
        vm.FavoriteTagFilter = FavoriteTagFilter;
        vm.SetSelectedUserType = SetSelectedUserType;
        vm.GetProfileRestrictedFields = GetProfileRestrictedFields;
        vm.IsFieldRestricted = IsFieldRestricted;
        
        vm.Initialize = Initialize;

        function GetProfileImageUrl() {
            if (!vm.User)
                return $filter('siteroot')('Images/Common/no_user_photo.png');

            return (vm.TempFile ? ($filter('ngfDataUrl')(vm.TempFile)) : ($filter('siteroot')(vm.User.Photo ? vm.User.Photo : 'Images/Common/no_user_photo.png')));
        }

        function IsFieldRestricted(field) {
            if (!vm.RestrictedFields) return false;

            var f = vm.RestrictedFields.find(rf => rf.FieldType === 1 && rf.Name.toLowerCase() === field.toLowerCase());
            return f !== undefined;
        }

        function GetProfileRestrictedFields() {
            userService.GetProfileRestrictedFields().then(GetProfileRestrictedFieldsSuccess);

            function GetProfileRestrictedFieldsSuccess(response) {
                vm.RestrictedFields = response.data;
            }
        }

        function GetUser() {
            userService.GetProfile().then(GetLoggedInUserSuccess); //GetLoggedInUserFromDB
            
            function GetLoggedInUserSuccess(response) {
                vm.Initialized = true;
                vm.User = response.data;
                vm.GetCustomFieldValue();
                vm.SetSelectedUserType();
            }
        }

        function GetCustomFieldValue() {
            userService.GetCustomFieldValue(1, vm.User.Id).then(GetCustomFieldValueSuccess);

            function GetCustomFieldValueSuccess(response) {
                if(response.data)
                    vm.CompanyNumber = response.data.Value ? response.data.Value : undefined;
            }
        }

        function UpdateCustomFieldValue() {
            userService.UpdateCustomFieldValue(1, vm.User.Id, vm.CompanyNumber).then(UpdateCustomFieldValueSuccess);

            function UpdateCustomFieldValueSuccess(response) {
            }
        }

        function SetTempFile(files) {
        	if (!files.length)
        		return;
				
        	vm.TempFile = files[0];
        	console.log(vm.TempFile);
        }

        function SetFile(file) {
        	if (file.length > 0) {
        		vm.File = file[0];

        		var settings = {
        			FileType: bizMediabankService.FileTypes.Image,
        			FileLocation: bizMediabankService.UploadLocations.UserProfile,
        			FilePattern: '',
        			IsPrivate: true,
        			IsInvisible: true,
        			IsPrivateControlHidden: true,
        			IsInvisibleControlHidden: true,
        			IsUser: true
        		}

        		var promise = bizMediabankUploadService.UploadFile(vm.File, vm.File.name, '', bizMediabankService.UploadLocations.UserProfile, true, true, settings, [], []);
        		promise.then(UploadFileSuccessCallback);

        		return promise;

        		function UploadFileSuccessCallback(response) {
        			if (response) {
        				var status = response.data;
        				vm.File = status.Object;
        				vm.User.Photo = vm.File.FileUrl;
        				$rootScope.LoggedInUser.Photo = vm.File.FileUrl;
        				vm.TempFile = undefined;
        				userService.SaveMyProfile(vm.User);
        			}
        		}
        	}
        }

        function SaveMyDetails(showToast) {
            if (vm.TempFile)
                vm.SetFile([vm.TempFile]).then(SuccessCallback);
            else {
                vm.User.UserTypeId = (vm.SelectedUserType && vm.SelectedUserType.Id > 0 ? vm.SelectedUserType.Id : -1);
                userService.SaveBasicProfile(vm.User).then(SuccessCallback);
            }

        	vm.UpdateAllowSMSForLoggedInUser();

            if (vm.CompanyNumber && vm.CompanyNumber != "")
                vm.UpdateCustomFieldValue();

            function SuccessCallback(response) {
            	$rootScope.LoggedInUser = angular.copy(vm.User);

                vm.IsEditMode = false;

                vm.MyForm.$setPristine();
                vm.MyForm.$setUntouched();

            	if (showToast){
            		$translate('CORE.DETAILSUPDATED').then(function(translation) {
            			$mdToast.show($mdToast.simple().content(translation).position("bottom right"));
            		});
            	}
            }
        }

        function Unregister() {
            userService.DeleteMe().then(DeleteMeSuccess);

            function DeleteMeSuccess() {
                window.location.href = siteRootPath;
            }
        }

        function AskToUnregister() {
            $translate('CORE.ASKTOUNREGISTER').then(function(translation) {
                $mdDialog.show({
                    templateUrl: bizCoreProvider.getView('base.dialog', 'FrontEnd/Views/Dialogs/dialog-primary.html'),
                    controller: profileDialogController,
                    controllerAs: "vm",
                    locals: {
                        Text: translation,
                        IsSureCheck: true
                    },
                    bindToController: true
                }).then(function (response) {
                    if (response) {
                        vm.Unregister();
                    }
                });
            });
        }

        function UpdateAllowSMSForLoggedInUser() {
            userService.UpdateAllowSMSForLoggedInUser(vm.AllowSms).then(UpdateAllowSMSForLoggedInUserSuccess).catch(UpdateAllowSMSForLoggedInUserError);

            function UpdateAllowSMSForLoggedInUserSuccess(response) {

            }

            function UpdateAllowSMSForLoggedInUserError(err) {
                vm.AllowSms = !vm.AllowSms;

                $translate('CORE.ERROR.SOMETHING').then(function (translation) {
                    $mdDialog.show({
                        templateUrl: bizCoreProvider.getView('base.dialog', 'FrontEnd/Views/Dialogs/dialog-primary.html'),
                        controller: profileDialogController,
                        controllerAs: "vm",
                        locals: {
                            Text: translation
                        },
                        bindToController: true
                    }).then(function (response) {
                    });
                });
            }
        }

        function GetLoggedInUserSetting(key, callback) {
            userService.GetLoggedInUserSetting(key).then(callback);
        }

        function GetLoggedInUserSettingAsBoolean(key, callback) {
            userService.GetLoggedInUserSettingAsBoolean(key).then(callback);
        }

        function FavoriteTagFilter(tag) {
        	return vm.ShowMoreFavorites || tag.Favorite === undefined || tag.Favorite;
        }

        function SetSelectedUserType() {
            if (vm.UserTypes && vm.User) {
                vm.SelectedUserType = vm.UserTypes.GetItemByValue('Id', vm.User.UserTypeId);
            }
        }

        function Initialize() {

            vm.GetProfileRestrictedFields();
        	vm.GetUser();

            vm.GetLoggedInUserSettingAsBoolean('blnAllowSMS', function(response) {
                vm.AllowSms = response.data;
            });

            bizCoreService.GetAllTags($rootScope.LoggedInUser.CurrentCultureId).then(GetTagsCallback);

            function GetTagsCallback(response) {
            	vm.Tags = response.data;
            }

            userService.GetUserTypes().then(GetUserTypesCallback);

            function GetUserTypesCallback(response) {
                vm.UserTypes = response.data;
                vm.UserTypes = $filter('orderBy')(vm.UserTypes, 'Name');
                vm.SetSelectedUserType();
            }
        }

        profileDialogController.$inject = ["$mdDialog"];

        function profileDialogController($mdDialog) {
            var vm = this;

            vm.Close = Close;
            vm.Ok = Ok;

            function Close() {
                $mdDialog.cancel();
            }

            function Ok() {
                $mdDialog.hide(true);
            }
        }

        $rootScope.Initialized.then(vm.Initialize);
    }

    function mycolleaguesController($rootScope, unitService) {
        var vm = this;
        vm.MyUnit = {};
        vm.UnitUsers = [];
        vm.Units = [];
        vm.ShowSpecificUnit = false;

        vm.GetUsersInUnit = GetUsersInUnit;
        vm.Initialize = Initialize;

        function InitializeUnit() {
            if ($rootScope.LoggedInUser.Units.length == 1) {
                vm.MyUnit = $rootScope.LoggedInUser.Units[0];

                if (~~vm.MyUnit.ParentId > 0) {
                    GetUnitsByParent(~~vm.MyUnit.ParentId);
                }
                else {
                    GetUsersInUnit(vm.MyUnit.Id);
                }
            }
            else {
                //Handle multiple units...
            }
        }

        function GetUsersInUnit(unitId) {
            vm.UnitUsers = [];
            unitService.GetUsersInUnit(unitId).then(GetUsersInUnitSuccess);

            function GetUsersInUnitSuccess(response) {
                vm.UnitUsers = response.data;
            }
        }

        function GetUnitsByParent(parentId) {
            unitService.GetUnitsByParent(parentId).then(GetUnitsByParentSuccess);

            function GetUnitsByParentSuccess(response) {
                vm.Units = response.data;
            }
        }

        function Initialize() {
            InitializeUnit();
        }

        vm.Initialize();
    }

    function myleaderboardsController($rootScope, unitService, leaderboardService) {
        var vm = this;
        vm.MyUnit = {};
        vm.MainUnitLeaderboard = [];
        vm.MainUnitLeaderboardMonth = [];
        vm.MainUnitLeaderboardYear = [];
        vm.UnitLeaderboard = [];
        vm.UnitLeaderboardMonth = [];
        vm.UnitLeaderboardYear = [];
        vm.Limit = 5;

        vm.Initialize = Initialize;
        vm.InitializeUnit = InitializeUnit;
        vm.GetMainUnitLeaderboard = GetMainUnitLeaderboard;
        vm.GetMainUnitLeaderboardBetweenDates = GetMainUnitLeaderboardBetweenDates;
        vm.GetUnitLeaderboard = GetUnitLeaderboard;
        vm.GetUnitLeaderboardBetweenDates = GetUnitLeaderboardBetweenDates;

        function InitializeUnit() {
            if ($rootScope.LoggedInUser.Units.length <= 1) {
            	vm.MyUnit = $rootScope.LoggedInUser.Units[0];
            }
            else {
                //Handle multiple units...
            }
        }

        function GetMainUnitLeaderboard() {
            leaderboardService.GetMainUnitLeaderboard(vm.Limit).then(GetMainUnitLeaderboardSuccess);

            function GetMainUnitLeaderboardSuccess(response) {
                vm.MainUnitLeaderboard = response.data;

                console.log('vm.MainUnitLeaderboard', vm.MainUnitLeaderboard);
            }
        }

        function GetMainUnitLeaderboardBetweenDates(startTime, endTime, callback) {
            leaderboardService.GetMainUnitLeaderboardBetweenDates(vm.Limit, startTime, endTime).then(callback);
        }

        function GetUnitLeaderboard() {
            leaderboardService.GetUnitLeaderboard(vm.Limit).then(GetUnitLeaderboardSuccess);

            function GetUnitLeaderboardSuccess(response) {
                vm.UnitLeaderboard = response.data;
            }
        }

        function GetUnitLeaderboardBetweenDates(startTime, endTime, callback) {
            leaderboardService.GetUnitLeaderboardBetweenDates(vm.Limit, startTime, endTime).then(callback);
        }

        function Initialize() {
        	InitializeUnit();

			if (vm.MyUnit && vm.MyUnit.ParentId){
				vm.GetMainUnitLeaderboard();
				vm.GetMainUnitLeaderboardBetweenDates(moment().startOf('month').format('YYYY-MM-DD hh:mm'), moment().endOf('month').format('YYYY-MM-DD hh:mm'), MonthLeaderboardCallback);
				vm.GetMainUnitLeaderboardBetweenDates(moment().startOf('year').format('YYYY-MM-DD hh:mm'), moment().endOf('year').format('YYYY-MM-DD hh:mm'), YearLeaderboardCallback);
			}

			if (vm.MyUnit){
				vm.GetUnitLeaderboard();
				vm.GetUnitLeaderboardBetweenDates(moment().startOf('month').format('YYYY-MM-DD hh:mm'), moment().endOf('month').format('YYYY-MM-DD hh:mm'), MonthUnitLeaderboardCallback);
				vm.GetUnitLeaderboardBetweenDates(moment().startOf('year').format('YYYY-MM-DD hh:mm'), moment().endOf('year').format('YYYY-MM-DD hh:mm'), YearUnitLeaderboardCallback);
			}

			if (!vm.MyUnit) {
				leaderboardService.GetCountryLeaderboard(vm.Limit).then(function (response) { vm.CountryLeaderboard = response.data; });

				leaderboardService.GetCountryLeaderboard(vm.Limit, moment().startOf('month').format('YYYY-MM-DD hh:mm'), moment().endOf('month').format('YYYY-MM-DD hh:mm'))
					.then(function (response) { vm.CountryLeaderboardMonth = response.data; });

				leaderboardService.GetCountryLeaderboard(vm.Limit, moment().startOf('year').format('YYYY-MM-DD hh:mm'), moment().endOf('year').format('YYYY-MM-DD hh:mm'))
					.then(function (response) { vm.CountryLeaderboardYear = response.data; });
			}
        }

        function MonthLeaderboardCallback(response) {
            vm.MainUnitLeaderboardMonth = response.data;
        }

        function YearLeaderboardCallback(response) {
            vm.MainUnitLeaderboardYear = response.data;
        }

        function MonthUnitLeaderboardCallback(response) {
            vm.UnitLeaderboardMonth = response.data;
        }

        function YearUnitLeaderboardCallback(response) {
            vm.UnitLeaderboardYear = response.data;
        }

        $rootScope.Initialized.then(vm.Initialize);
    }
})(window.angular);
